import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {InvoiceLayout} from '../../../Models/InvoiceLayout';
import {BehaviorSubject} from 'rxjs';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';
import {FileItem, FileUploader, ParsedResponseHeaders} from 'ng2-file-upload';
import {environment} from '../../../../../environments/environment';
import {Helper} from '../../../../helpers/helper.service';
import {AuthenticationService} from '../../../../shared/Services/authentication.service';
import {InvoiceLayoutDetails} from '../../../Models/InvoiceLayoutDetails';
import {InvoiceLayoutService} from '../../../Services/invoice-layout.service';
import {ActivatedRoute, Router} from '@angular/router';

const baseUri = environment.apiUrl;
const URL = baseUri + '/backoffice/file_manager?bupload=invoiceLayout.logo&generate-default=false&quality=75';

@Component({
  selector: 'app-manage-invoice-layout',
  templateUrl: './manage-invoice-layout.component.html',
  styleUrls: ['./manage-invoice-layout.component.scss']
})
export class ManageInvoiceLayoutComponent implements OnInit {


  @ViewChild('uploadEl', {static: false}) uploadElRef: ElementRef;
  @ViewChild('imageElement', {static: false}) imageElement: ElementRef;
  @ViewChild('companyDetailsModal', {static: false}) companyDetailsModal = null;
  @ViewChild('addCompanyDetailsForm', {static: false}) addCompanyDetailsForm;

  public layout: InvoiceLayout = new InvoiceLayout();
  public status = [
    {label: this.translate.instant('global.active'), value: true},
    {label: this.translate.instant('global.inactive'), value: false},
  ];
  public modules: any;
  public iframeUrl: SafeResourceUrl;
  public imageUrl = null;

  public uploader: FileUploader = new FileUploader({
    itemAlias: 'logo',
    url: URL,
    authToken: this.auth.getBearerHeader(),
  });

  private target: any;
  public addFileItem = false;
  public isUploading = false;
  public isNotAdd = false;
  public oldLogoId = null;
  public isEdit = false;
  public layoutId: number;

  private fileRemoveFileId = null;
  companyDetails: InvoiceLayoutDetails[] = [];
  private editCompanyDetails = false;
  layoutTypes = [
    {
      label: this.translate.instant('pdf.invoice'),
      value: false
    },
    {
      label: this.translate.instant('pdf.credit_invoice'),
      value: true
    }
  ];


  constructor(
    private translate: TranslateService,
    public helper: Helper,
    private auth: AuthenticationService,
    private layoutService: InvoiceLayoutService,
    private router: Router,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer
  ) {

    this.layout.status = true; // Set status default value

    this.modules = {
      toolbar: {
        container: [
          ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
          [{'script': 'sub'}, {'script': 'super'}],      // superscript/subscript
          [{'header': [1, 2, 3, 4, 5, 6, false]}],
          [{'color': []}, {'background': []}],          // dropdown with defaults from theme
          ['clean'],                                         // remove formatting button
          ['link'],                         // link and image, video
        ],
      },
    };

  }

  ngOnInit() {
    this.uploader.onAfterAddingFile = (item => {
      if (this.target) {
        this.target.value = '';
      }
      item.withCredentials = false;
    });

    this.route.params.subscribe(params => {
      if (Helper.isDefined(params['id'])) {
        this.layoutId = params['id'];
        this.isEdit = true;
        this.layoutService.getInvoiceLayout(this.layoutId).subscribe((resp) => {
          delete resp.id;
          resp.invoiceLayoutDetails.forEach(function (row) {
            delete row.id
          });
          this.layout = JSON.parse(JSON.stringify(resp));
          this.imageUrl = environment.absolutePath + '/' + resp.logo.fullPath;
          this.layout.logo = resp.logo.id;
          this.oldLogoId = JSON.parse(JSON.stringify(resp.logo.id));
          this.preview();
        });
      }
    });

  }

  saveLayout(preview = false) {
    new Promise((resolve) => {
      if (this.uploader.queue.length > 0 && !this.uploader.queue[0].isUploaded) {
        this.uploadFile(() => {
          resolve(true);
        });
      } else if (null !== this.layout.logo) {
        resolve(true);
      }
    }).then(() => {
      if (preview) {
        this.layoutService.previewInvoiceLayout(this.layout).subscribe(res => {
          this.updateIframe(res);
        });
      } else {
        this.layoutService.manageLayout(this.layout, this.isEdit, this.layoutId).subscribe((response: InvoiceLayout) => {
          if (null !== this.oldLogoId && this.oldLogoId !== response.logo.id) {
            this.layoutService.removeImage(this.oldLogoId, response.id).subscribe();
          }
          this.router.navigateByUrl('/back-office/invoice-layout/overview');
        });
      }
    });
  }

  uploadFile(cb) {
    this.addFileItem = true;
    this.isUploading = true;
    this.uploader.uploadAll();
    this.uploader.onErrorItem = (item: FileItem, response, status: number, headers: ParsedResponseHeaders) => {
      this.isUploading = false;
      this.uploader.clearQueue();
      this.uploadElRef.nativeElement.value = '';
      const res = JSON.parse(response);
      this.helper.popMessageDialog(res.title, res.errors);
    };
    this.uploader.onSuccessItem = (item: FileItem, response: string, status: number, headers: ParsedResponseHeaders) => {
      if (response) {
        this.addFileItem = false;
        this.isUploading = false;
        this.isNotAdd = false;
        const res = JSON.parse(response);
        this.imageUrl = environment.absolutePath + '/' + res.fullPath;
        this.layout.logo = res.id;
        cb();
      }
    };
  }

  changeImage(event) {
    this.imageUrl = null;
    this.isUploading = false;
    this.uploader.clearQueue();
    const element: HTMLElement = document.getElementById('uploaderFile') as HTMLElement;
    element.click();
  }

  fileChange($event: Event) {
    const reader = new FileReader();
    reader.onloadend = (e) => {
      this.imageUrl = reader.result;
    };
    if (this.uploader.queue[0]._file) {
      return reader.readAsDataURL(this.uploader.queue[0]._file);
    }
  }

  removeImage(file) {
    this.isUploading = true;
    if (file && file.hasOwnProperty('id')) {
      this.fileRemoveFileId = file.id;
    }
    this.imageUrl = null;
    this.isUploading = false;
    this.layout.logo = null;
    this.uploader.clearQueue();
    this.uploadElRef.nativeElement.value = '';
  }

  addCompanyDetails() {
    if (this.layout.invoiceLayoutDetails && this.layout.invoiceLayoutDetails.length > 0) {
      this.editCompanyDetails = true;
      this.companyDetails = JSON.parse(JSON.stringify(this.layout.invoiceLayoutDetails));
    } else {
      this.companyDetails = [];
      this.companyDetails.push(new InvoiceLayoutDetails());
    }
    this.companyDetailsModal.show();
  }

  addNewRow() {
    this.companyDetails.push(new InvoiceLayoutDetails());
  }

  removeCompanyDetails(index) {
    this.companyDetails.splice(index, 1);
  }

  manageCompanyDetails() {
    this.layout.invoiceLayoutDetails = JSON.parse(JSON.stringify(this.companyDetails));
    this.companyDetailsModal.hide();
  }

  isValid() {
    return !this.isUploading && (this.uploader.queue.length > 0 || this.layout.logo);
  }

  preview() {
    this.saveLayout(true);
  }

  updateIframe(resp) {
    const pdfBlob = new Blob([resp.body], {type: 'application/pdf'});
    const pdfUrl = window.URL.createObjectURL(pdfBlob);
    this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(pdfUrl);
  }

  isSetLayoutType(type: boolean) {
    if ((this.layoutTypes.findIndex(layout => layout.value === type) !== -1)) {
      return false;
    }
    return true;
  }
}
